import dayjs from "dayjs";

const expires = new Date(dayjs().add(12, "hour").toDate());

export function CookiesConfig() {
    const { NODE_ENV } = process.env;

    if (NODE_ENV === "production") {
        return {
            expires: expires,
            sameSite: "lax",
            secure: true,
        };
    }

    return {
        expires: expires,
    };
}

export const CookiesName = {
    TOKEK: "tokek",
};

export const XCustomHeaderName = {
    TOKEK: "tokek",
};
